import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_1941790367 from "../../../../../packages/component/src/components/switch/demo/demo1.js?loadDemo";
import legacyImportDemo_3734003196 from "../../../../../packages/component/src/components/switch/demo/demo2.js?loadDemo";
import legacyImportDemo_2346543197 from "../../../../../packages/component/src/components/switch/demo/demo3.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_1941790367,
  legacyImportDemo_3734003196,
  legacyImportDemo_2346543197,
  React
};